module.exports = __webpack_public_path__ + "static/majestic_villa-8e69f3475a8ad7a55106147ad75941ac.pdf";